const SET_UI_ERROR = "SET_UI_ERROR";
const SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR";
const SET_THEME = "SET_THEME";

const initialState = {
  theme: "ddhq",
  uiError: null,
  globalErrors: [],
};

const mutations = {
  [SET_UI_ERROR](state, uiError) {
    state.uiError = uiError;
  },
  [SET_GLOBAL_ERROR](state, error) {
    if (state.globalErrors.includes(error) === false) {
      state.globalErrors.push(error);
    }
  },
  [SET_THEME](state, theme) {
    state.theme = theme;
  },
};

const actions = {
  setUiError({ commit }, uiError) {
    commit(SET_UI_ERROR, uiError);
  },
  setGlobalError({ commit }, message) {
    let error = message;
    if (message === "Unexpected end of JSON input") {
      error =
        "Looks like an issue with the topojson file. It may not exist, or the url override field is wrong for the selected race type. Reload the page and try again.";
    }
    commit(SET_GLOBAL_ERROR, error);
  },
  setTheme({ commit }, theme) {
    commit(SET_THEME, theme);
  },
};

const getters = {
  theme(state) {
    return state.theme;
  },
  uiError(state) {
    return state.uiError;
  },
  globalErrors(state) {
    return state.globalErrors;
  },
};

export default {
  namespaced: false,
  state: initialState,
  mutations,
  actions,
  getters,
};
